import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { fetchCTraderSignalStatuses, getCTraderSignalStats, CTraderSignalFilters } from '@/services/ctrader-signal-service';

export const useCTraderSignals = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState<CTraderSignalFilters>({
    status: 'all',
  });

  const {
    data: signalsData,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['ctrader-signals', page, pageSize, filters],
    queryFn: () => fetchCTraderSignalStatuses(page, pageSize, filters),
    refetchInterval: 30000, // Auto-refresh every 30 seconds
  });

  const {
    data: stats,
    isLoading: isStatsLoading
  } = useQuery({
    queryKey: ['ctrader-signal-stats'],
    queryFn: getCTraderSignalStats,
    refetchInterval: 30000,
  });

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPage(1); // Reset to first page
  };

  const handleFiltersChange = (newFilters: CTraderSignalFilters) => {
    setFilters(newFilters);
    setPage(1); // Reset to first page
  };

  return {
    signals: signalsData?.data || [],
    total: signalsData?.total || 0,
    page,
    pageSize,
    filters,
    stats,
    isLoading,
    isStatsLoading,
    error,
    handlePageChange,
    handlePageSizeChange,
    handleFiltersChange,
    refetch
  };
};